import { render, staticRenderFns } from "./StatusChip.vue?vue&type=template&id=38ff58a2&scoped=true&lang=pug"
import script from "./StatusChip.vue?vue&type=script&lang=ts"
export * from "./StatusChip.vue?vue&type=script&lang=ts"
import style0 from "./StatusChip.vue?vue&type=style&index=0&id=38ff58a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ff58a2",
  null
  
)

export default component.exports